<template>
  <div>
    <div class="row mb-2">
      <div class="col-lg-3" style="max-width: 180px;">
        <div v-if="user.profile_pic == 'https://enginehireio-static-and-media.s3.amazonaws.com/media/profile_pics/default_avatar.jpg' && user.external_profile_pic">
          <img :src="user.external_profile_pic" style="max-width: 150px;">
        </div>
        <div v-else>
          <img :src="user.profile_pic" style="max-width: 150px; border-radius: 3px;">
        </div>
        <!-- {{ user.linkedin }} -->
        <!-- <button class="mylisting-button dark-button" v-if="user.id == $store.getters.userID">Edit</button> -->


      </div>
      <div v-if="editAccess" class="col-lg-4" style="width: 100%;">
        <!-- {{ editAccess }} -->
        <!-- {{$store.getters.isAgent}} -->
        <!-- <label>Name</label> -->
        <h3 class="mt-2" style="margin-bottom: 0;">{{ user.first_name }} <span v-if="!viewOnlyAccess">{{ user.last_name }}</span>
          <img v-if="editAccess" class="mb-1 ml-1" src="../../../assets/img/icons/edit_icon_simple.svg" alt="" width="16px" style="cursor: pointer;" @click="editBasicInfo()">
        </h3>

        <p class="mt-2 mb-2" style="margin-bottom: 0;">{{ user.phone }} | {{ user.email }} </p>
        <p style="margin-bottom: 0;">{{ user.address1 }}</p>
        <p style="margin-bottom: 0;">{{ user.address2 }}</p>
        <p class="" style="margin-bottom: 0;">{{ user.city }}<span v-if="user.provincestate">, </span>{{ user.provincestate }}<span v-if="user.country">, </span>{{ user.country }}</p>
        <p>{{ user.postal_code }}</p>
        <p v-if="user.date1">Date of Birth: {{ new Date(addCurrentTimeToDate(user.date1)).toDateString() }} (Age: {{ getAge(new Date(user.date1).toDateString()) }})</p>
        <p v-if="user.birthday">Date of Birth: {{ new Date(addCurrentTimeToDate(user.birthday)).toDateString() }} (Age: {{ getAge(new Date(user.birthday).toDateString()) }})</p>
        <!-- <div class="mt-3">
          <a v-if="user.facebook" :href="user.facebook" target="_blank">
            <img src="../../../assets/img/social/facebook_squircle_charcoal.svg" alt="facebook" class='social-icon'>
          </a>
          <a v-if="user.instagram" :href="user.instagram" target="_blank">
            <img src="../../../assets/img/social/instagram_squircle_charcoal.svg" alt="instagram" class='social-icon'>
          </a>
        </div> -->
        <!-- <label v-if="user.text12">Facebook</label>
        <p>{{ user.text12 }}</p>
        <label v-if="user.text13">Instagram</label>
        <p>{{ user.text13 }}</p> -->

        <!-- <hr style="margin-bottom: 0;"> -->
        <!-- <label v-if="user.overview">What makes me a great nanny</label>
        <pre style="margin-bottom: 0;">{{ user.overview }}</pre>
        <label v-if="user.text_field1">Hobbies/Activities I do in my free time</label>
        <pre style="margin-bottom: 0;">{{ user.text_field1 }}</pre>
        <label v-if="user.selector1">What type of caregiver am I</label>
        <p>{{ user.selector1 }}</p> -->

        <!-- <hr>
        <p>Record a one minute video introducing yourself.</p>
        <button class="mylisting-button dark-button" @click="loadRecorder">Record Video</button>
        <div class="" id="custom-id"></div> -->

      </div>
      <div class="col-lg-5">
        <h3 v-if="viewOnlyAccess" class="mt-2" style="margin-bottom: 0;">{{ user.first_name }}
          <!-- <span v-if="!viewOnlyAccess">{{ user.last_name }}</span> -->
        </h3>
        <!-- <label v-if="user.overview">What makes me a great nanny</label>
        <pre style="margin-bottom: 0;">{{ user.overview }}</pre>
        <label v-if="user.text_field1">Hobbies/Activities I do in my free time</label>
        <pre style="margin-bottom: 0;">{{ user.text_field1 }}</pre>
        <label v-if="user.selector1">What type of caregiver am I</label>
        <p>{{ user.selector1 }}</p> -->

        <pre v-if="$store.getters.isEmployer === true">{{ user.text20 }}</pre>
      </div>

      <!-- <div class="col-lg-8" v-if="adminOrEmployer">
        <pre>{{ user.text20 }}</pre>
      </div> -->
    </div>

  </div>
</template>

<script>
export default {
  props: ['user'],
  computed: {
    editAccess() {
      if ((this.user.id == this.$store.getters.userID) || this.$store.getters.isAgent === true) {
        return true
      } else {
        return false
      }
    },
    viewOnlyAccess() {
      if (this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    },
    adminOrEmployer() {
      if (this.$store.getters.isAgent === true || this.$store.getters.isEmployer === true) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    editBasicInfo() {
      this.$emit('editBasicInfo')
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/candidates/profile/BasicInfo.vue